// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"81b5cecc","56":"09071001","311":"2af8a3b4","336":"20fdae53","380":"2406bf6f","384":"6c5f9932","392":"ba39d36c","417":"526e4bbd","665":"c1239090","895":"2348a9e4","912":"9eb9529b"}[chunkId] + ".chunk.js";
};